import PolicyCards from './PolicyCards'

export default PolicyCards
